import { render } from "./BarbarianView.vue?vue&type=template&id=a9048eec&scoped=true"
import script from "./BarbarianView.vue?vue&type=script&lang=js"
export * from "./BarbarianView.vue?vue&type=script&lang=js"

import "./BarbarianView.vue?vue&type=style&index=0&id=a9048eec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9048eec"]])

export default __exports__